<template>
  <div class="sidebar" :data="backgroundColor">
    <div class="sidebar-wrapper" id="style-3">
      <div class="logo">
        <div class="sidebar-brand">
          <span class="sidebar-title">{{ title }}</span>
        </div>
      </div>

      <slot></slot>

      <ul class="nav">
        <slot name="links">
          <sidebar-link
            v-for="(link, index) in sidebarLinks"
            :key="index"
            :to="link.path"
            :name="link.name"
            :icon="link.icon"
          />
        </slot>
      </ul>
    </div>
  </div>
</template>

<script>
import SidebarLink from "./SidebarLink";

export default {
  props: {
    title: {
      type: String,
      default: "ConsultIA",
    },
    backgroundColor: {
      type: String,
      default: "vue",
    },
    activeColor: {
      type: String,
      default: "success",
    },
    sidebarLinks: {
      type: Array,
      default: () => [],
    },
    autoClose: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    SidebarLink,
  },
};
</script>

<style>
.sidebar-brand {
  display: flex;
  align-items: center;
  padding: 16px 14px 10px;
}

.sidebar-title {
  font-weight: 800;
  font-size: 1.1rem;
  color: #ffffff;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  line-height: 1.2;
}
</style>